<div id="slick-tabs_{{uuid}}" class="slick-tabs">
	<div class="slick-tab-headers" [ngClass]="{'no-border': hideBorder === true}">
		<ng-content></ng-content>
	</div>
	<div id='slick-tab-display-body_{{uuid}}' class="slick-tab-display-body"></div>
</div>